/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.package').controller('AdHocSelectPartnersModalController',
	function ($uibModalInstance, currentPartners, isSeries, isSeason, isVolume, allPartners) {

		var self = this;

		self.availablePartners = [];
		self.selectedPartners = [];
		self.isSeries = isSeries;
		self.isSeason = isSeason;
		self.isVolume = isVolume;

		self.subType = '';

		function filterPartners () {
			self.availablePartners = allPartners.filter(function (partner) {
				var found = false;
				for(var i = 0; i < currentPartners.length; i++) {
					if(currentPartners[i].id === partner.id) {
						found = true;
						break;
					}
				}
				return !found;
			});
		}

		this.onOk = function () {
			$uibModalInstance.close({selectedPartners: self.selectedPartners, subType: self.subType});
		};

		this.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		this.disableOKButton = function () {
			return self.selectedPartners.length < 1 || (self.isSeries && !self.subType);
		};

		filterPartners();
	});
